import TicketDetails from "./TicketDetails";
import TicketDetailsProvider from "./TicketDetailsContext";

let Index = () => {

    return (
        <TicketDetailsProvider>
            <TicketDetails />
        </TicketDetailsProvider>
    );
}


export default Index;